import React from 'react';
import { useTranslation } from 'react-i18next';
import PersonPinOutlined from '@mui/icons-material/PersonPinOutlined';
import Typography from '@mui/material/Typography';
import BreadCrumb from 'shared/components/bread-crumb/bread-crumb/bread-crumb';

import './organization-unit-name-column.scss';

export const OrganizationUnitNameColumnHeader = (): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  return <div style={{ paddingLeft: 16 }}>{t('residentsTable.column.organisationUnitName')}</div>;
};

type Props = {
  electronicClientRecordName?: string;
  residentSettingName: string;
  breadCrumbs: string[];
  isSelected: boolean;
};

const OrganizationUnitNameColumn = ({
  electronicClientRecordName,
  residentSettingName,
  breadCrumbs,
  isSelected,
}: Props): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const renderBreadCrumbs = (parentTitle: string, index: number): React.JSX.Element => (
    <Typography
      data-testid={`resident-breadcrumb-child-${index}`}
      key={`Resident_Breadcrumb_Child_${parentTitle}`}
      variant="caption"
      className="bread-crumb-item"
    >
      {parentTitle}
    </Typography>
  );

  return (
    <div className="organization-unit-name-column-container">
      <div className="organization-unit-name-column-status">
        <PersonPinOutlined />
      </div>
      <div className="organization-unit-name-column-information">
        <Typography variant="body2" className="resident-of">
          {electronicClientRecordName ?? t('residentOf')}
        </Typography>
        <Typography variant="subtitle2" className={`resident-setting-name ${isSelected ? 'selected' : ''}`}>
          {residentSettingName}
        </Typography>
        <BreadCrumb
          showEllipsis={breadCrumbs.length > 2}
          allElementNames={breadCrumbs}
          data-testid={`resident-breadcrumb-child-${residentSettingName}`}
        >
          {breadCrumbs.map((parentTitle, index) => renderBreadCrumbs(parentTitle, index))}
        </BreadCrumb>
      </div>
    </div>
  );
};

export default OrganizationUnitNameColumn;
